import styled, { css } from 'styled-components';

import Link from '~/src/common/components/Link';

export const Container = styled.div`
  display: flex;
  padding: 16px;
  gap: 16px;
  align-items: center;

  border-radius: 8px;
  color: ${({ theme }) => theme.palette.common.PRIMARY};
  background: ${({ theme }) => theme.palette.common.XLIGHT_GREEN};
`;

export const Icon = styled.img`
  flex: 0 0 auto;
  display: block;
  max-height: 64px;
`;

export const Text = styled.p`
  margin: 0;
  padding: 0;
  flex: 1 1 auto;
  color: ${({ theme }) => theme.palette.common.PRIMARY};

  > strong {
    display: block;
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    transform: translateY(-0.03em); /* Fix position */
    font-family: ${({ theme }) => theme.fonts.quaternary};
  }

  > span {
    display: block;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
  }
`;

export const Action = styled(Link)`
  flex: 0 0 auto;
  display: block;
  padding: 8px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  ${({ theme }) => css`
    color: ${theme.palette.common.WHITE};
    background: ${theme.palette.common.PRIMARY};

    &:hover {
      color: ${theme.palette.common.WHITE};
      background: ${theme.palette.common.PRIMARY_HOVER};
    }
  `}
`;
